import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import dayjs from "dayjs";
import { RootState } from "app/store";
import I18n from "common/i18n";
import { ChatInputBar } from "common/elements";
import { sendChatRoomMessage } from "features/user/api";
import {
  AccountType,
  MessageType,
  ChatRoomMemberType,
  MessageContentType,
} from "features/user/types";

export const InputBar = (props: { visible: boolean }) => {
  const { visible } = props;
  const selectedChatRoomId = useSelector((state: RootState) => state.user.selectedChatRoomId);
  const user = useSelector((state: RootState) => state.user.active);

  const handleSend = (text: string, imageUrl?: string) => {
    if (!text && !imageUrl) return;

    // タイプ判定: imageUrl あり && text あり → IMAGE_WITH_TEXT
    const hasImage = !!imageUrl;
    const hasText = !!text.trim();
    const contentType = hasImage
      ? hasText
        ? MessageContentType.IMAGE_WITH_TEXT
        : MessageContentType.IMAGE
      : MessageContentType.TEXT;
    const content = hasImage
      ? hasText
        ? { url: imageUrl, text: text.trim() }
        : { url: imageUrl }
      : { text };

    const message = {
      user_uid: user.uid,
      user_type:
        user.account_type === AccountType.PARENTS
          ? ChatRoomMemberType.PARENTS
          : ChatRoomMemberType.KIDS,
      message_type: MessageType.NORMAL,
      message_content_type: contentType,
      message_content: content,
      created_at: dayjs().format("YYYY-MM-DD HH:mm:ss"),
      updated_at: dayjs().format("YYYY-MM-DD HH:mm:ss"),
    };

    sendChatRoomMessage({
      roomId: selectedChatRoomId,
      message,
    }).catch((error) => {
      console.error(error);
      toast(
        <div>
          <p className="text text-textcolor-black">{I18n.t("MSG_TOAST_SEND_FAILED")}</p>
        </div>,
      );
    });
  };

  return (
    <div
      className="flex-col-view justify-start items-center w-full z-50 bg-white"
      style={{ display: !visible && "none" }}
    >
      <ChatInputBar
        onSend={handleSend}
        disabled={selectedChatRoomId === null}
        placeholder={I18n.t("MSG_USER_PROFILE_MESSAGE_CHAT_PLACEHOLDER")}
      />
    </div>
  );
};
